import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchOrderDetails, updateOrderStatus, cancelOrder as cancelOrderApi } from "../services/useService";
import { Order } from "src/shared/services/interfacev2";

export const useOrder = () => {
  const navigate = useNavigate();
  const { orderid } = useParams<{ orderid: string }>();

  const [order, setOrder] = useState<Order | null>(null);
  const [status, setStatus] = useState<string>("Confirm");
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [isCancelDisabled, setIsCancelDisabled] = useState(false);

  useEffect(() => {
    const fetchOrder = async () => {
      if (!orderid) {
        setError("Order ID is missing");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await fetchOrderDetails(orderid);

        const orderData = response.data.result || response.data;
        setOrder(orderData);
        setStatus(orderData?.OrderStatus || "Confirm");
      } catch {
        setError("Failed to fetch order details");
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [orderid]);

  // ✅ Correct logging
  useEffect(() => {
    if (order) {
    }
  }, [order]);

  const handleStatusChange = async (event: any) => {
    const newStatus = event.target.value;
    setStatus(newStatus);

    if (!orderid) {
      setError("Order ID is missing");
      return;
    }

    try {
      await updateOrderStatus(orderid, newStatus);
      setError(null);
    } catch {
      setError("Failed to update the order status");
    }
  };

  const cancelOrder = async () => {
    if (!orderid) return;

    setIsCancelDisabled(true);
    try {
      await cancelOrderApi(orderid);
      toast.success("Order canceled successfully", {
        position: "top-right",
        autoClose: 3000,
      });

      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch {
      toast.error("Failed to cancel order", {
        position: "top-right",
        autoClose: 3000,
      });
      setIsCancelDisabled(false);
    }
  };

  return {
    order,
    setOrder,
    status,
    setStatus,
    loading,
    error,
    setError,
    handleStatusChange,
    cancelOrder,
    isCancelDisabled,
  };
};
